import XLSX from "xlsx";

export default {
  downloadWorkbook(wb, filename) {
    let wopts = { bookType: "xlsx", bookSST: false, type: "binary" };
    XLSX.writeFile(wb, filename + ".xlsx", wopts);
  },
  createWorkbook(worksheets, titles) {
    var workbook = XLSX.utils.book_new();
    worksheets.forEach((ws, i) => {
      XLSX.utils.book_append_sheet(
        workbook,
        ws,
        titles[i],
      );
    });
    return workbook;
  },
  createInvoiceWorksheet(data) {
    // Expect object of the following form:
    // {
    //   pricing: { panel: INT price_per, mcc: INT price_per, ... },
    //   locations: [
    //     { title: STR, panel: INT count, mcc: INT count, ... },
    //   ],
    // }

    let map = [
      {
        countLabel: 'panels',
        priceLabel: 'panel',
        label: 'Panels',
      },
      {
        countLabel: 'mccs',
        priceLabel: 'mcc',
        label: 'MCCs',
      },
      {
        countLabel: 'breakers',
        priceLabel: 'breaker',
        label: 'Breakers',
      },
      {
        countLabel: 'disconnects',
        priceLabel: 'disconnectSwitch',
        label: 'Disconnects Switches',
      },
      {
        countLabel: 'dps',
        priceLabel: 'distributionPanelboard',
        label: 'Distribution Panelboard',
      },
      {
        countLabel: 'fuses',
        priceLabel: 'fuse',
        label: 'Fuses',
      },
      {
        countLabel: 'softstarts',
        priceLabel: 'softstart',
        label: 'Softstarts',
      },
      {
        countLabel: 'starters',
        priceLabel: 'starter',
        label: 'Starters',
      },
      {
        countLabel: 'switchboards',
        priceLabel: 'switchboard',
        label: 'Switchboards',
      },
      {
        countLabel: 'transformers',
        priceLabel: 'transformer',
        label: 'Transformers',
      },
      {
        countLabel: 'vfds',
        priceLabel: 'vfd',
        label: 'VFDs',
      },
    ];

    let totalPrice = 0;
    let rows = [
      [
        'Type',
        ...data.locations.map((_, i) => i == 0 ? '# for Each Location' : ''),
        '# for All Locations',
        'Per-Unit Price',
        'Total Price',
      ],
      [
        '',
        ...data.locations.map((location) => location.title),
        '',
        '',
        '',
      ],
      ...map.map((obj) => {
        var totalUnits = data.locations.reduce((accumulator, location) => accumulator + parseInt(location[obj.countLabel]), 0);
        var priceForUnits = data.pricing[obj.priceLabel] * totalUnits
        totalPrice += priceForUnits;
        return [
          obj.label,
          ...data.locations.map((location) => location[obj.countLabel]),
          totalUnits,
          `$${data.pricing[obj.priceLabel]}`,
          `$${priceForUnits}`,
        ];
      }),
      [
        '',
        ...data.locations.map((location) => ''),
        '',
        '',
        `$${totalPrice}`,
      ],
    ];

    let ws_data = [...rows];

    return XLSX.utils.aoa_to_sheet(ws_data);
  },
};